import React from "react";
import OverviewSection from "./OverviewSection";
import PerformanceSection from "./PerformanceSection";
import ProgressSection from "./ProgressSection";
import BehavioralSection from "./BehavioralSection";
import EmotionalSection from "./EmotionalSection";
import FeedbackSection from "./FeedbackSection";
import AssignmentSection from "./AssignmentSection";

const AIAnalysisContent = ({ activeSection, report ,linkedUser}) => {
  
  const renderContent = () => {
    switch (activeSection) {
      case "overview":
        return <OverviewSection report={report} />;
      case "performance":
        return <PerformanceSection report={report} />;
      case "progress":
        return <ProgressSection report={report} />;
      case "behavioral":
        return <BehavioralSection report={report} />;
      case "emotional":
        return <EmotionalSection report={report} />;
      case "feedback":
        return <FeedbackSection report={report} />;
      case "assignment":
        return <AssignmentSection user={linkedUser} />;
      default:
        return <OverviewSection report={report} />;
    }
  };

  return <div className="mt-4">{renderContent()}</div>;
};

export default AIAnalysisContent;
